import React, { useState, useContext, useEffect } from 'react';
import { Modal, FormGroup, Label, Row, Col, Container } from 'reactstrap';
// import moment from 'moment';

import { symbolPriceFormatter } from '~/helpers/price';
import { PedidoContext } from '~/context/PedidoContext';
// import { ExtratoContext } from '~/context/ExtratoContext';
import { CloseOutlined } from '@mui/icons-material';

import { color } from '~/assets/styles/colors';
import { LoaderMini, LoaderLista } from '../../Loaders';

import {
	ModalFooterCss,
	Title,
	InputDescriptionCss,
	InputCss,
	ButtonCss,
	ModalBodyCss,
	TextStatus,
} from './styles';

export function ModalVisualizarSN(props) {
	const { toggle, idPedido, numPedido, tipo, setToggle } = props;

	const { getPedidoIndividual } = useContext(PedidoContext);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (toggle) {
			getPedidoIndividual(idPedido.toString(), tipo).then((res) => {
				setCampos(res.data.pedido);
				setLoading(false)
			});
			setLoading(true)
		}
	}, [toggle]);

	const [campos, setCampos] = useState({
		id: '',
		nome_destinatario: '',
		nome: '',
		documento: '',
		data_pedido: '',
		contato: '',
		nota_fiscal: '',
		descricao: '',
		valor_pedido: 0,
		status: 1,
	});

	const colorItem = {
		aprovado: color.green,
		reprovado: color.red,
		pendente: color.yellow,
		title: color.red,
	};

	return (
		<>
			<Modal
				isOpen={toggle}
				size="xl"
				style={{ maxWidth: 990, width: '100%' }}>
				<Title className="d-flex align-items-center justify-content-between">
					Ordem de Pagamento ID Nº #
					{numPedido || <LoaderMini />}
					<ButtonCss
						style={{
							borderRadius: 0,
							backgroundColor: color.primary,
							border: `1px solid ${color.primary}`,
						}}
						className="d-flex align-items-center justify-content-center"
						onClick={() => { setToggle(false) }}>
						<CloseOutlined />
					</ButtonCss>
				</Title>

				{!loading ?
					<>
						<ModalBodyCss>
							<Container xs="12" md="12" lg="12">
								<Row xs="12" md="12" lg="12">
									<Col xs="12" md="12" lg="5">
										<FormGroup>
											<Label>{tipo === 'solicitados' ? 'Destinatário' : 'Solicitante'}</Label>
											<InputCss
												disabled
												value={tipo === 'solicitados' ? campos.nome_destinatario : campos.nome}
											/>
										</FormGroup>
									</Col>
									<Col xs="6" md="6" lg="4">
										<FormGroup>
											<Label>Nº Refêrencia do Pedido</Label>
											<InputCss
												disabled
												value={numPedido}
											/>
										</FormGroup>
									</Col>
									<Col xs="6" md="6" lg="4">
										<FormGroup>
											<Label>Valor do Pedido</Label>
											<InputCss
												disabled
												value={symbolPriceFormatter(campos.valor_pedido)}
											/>
										</FormGroup>
									</Col>
									<Col xs="6" md="6" lg="3">
										<FormGroup>
											<Label>Nota Fiscal</Label>
											<InputCss
												disabled
												value={campos.nota_fiscal > 0 ? campos.nota_fiscal : '-'}
											/>
										</FormGroup>
									</Col>
									<Col style={{ textAlign: 'right' }} xs="12" md="6" lg="8">
										<FormGroup>
											<Label>Status</Label>
											<div>
												<TextStatus style={{ color: colorItem[campos.status.toLowerCase()] }}>
													{campos.status}
												</TextStatus>
											</div>
										</FormGroup>
									</Col>
								</Row>

								<FormGroup>
									<Label>Descrição do pedido</Label>
									<InputDescriptionCss
										type="textarea"
										name="descricao"
										value={campos.descricao}
										disabled
									/>
								</FormGroup>
							</Container>
						</ModalBodyCss>

						<ModalFooterCss>
							<ButtonCss
								style={{
									backgroundColor: '#FFFFFF',
									border: '1px solid #4A4A49',
								}}
								size="sm"
								onClick={() => { setToggle(false) }}>
								FECHAR
							</ButtonCss>
						</ModalFooterCss>
						{' '}

					</> : <LoaderLista loading={loading} lista={[]} />}
			</Modal>
		</>
	);
}
